import{a as d}from"./ids-chunk-3DA43NO3.js";import{a as i,b as s}from"./ids-chunk-XE4WFW5M.js";import{a as n}from"./ids-chunk-EV6LM7KM.js";import{e as a}from"./ids-chunk-5Q3WPKMB.js";import{a as r}from"./ids-chunk-4O5N6MTO.js";import{a as t}from"./ids-chunk-Y32WUP63.js";var c=`/* Ids Badge Component */
:host {
  display: inline-flex;
  contain: content;
  text-align: center;
}

:host(.disabled) .ids-badge,
:host([disabled]) .ids-badge,
:host-context(.disabled) .ids-badge,
:host-context([disabled]) .ids-badge {
  opacity: var(--ids-badge-disabled-opacity);
}

.ids-badge {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--ids-badge-color-background);
  border: 1px solid var(--ids-badge-color-border);
  border-radius: var(--ids-badge-border-radius);
  color: var(--ids-badge-color-text-default);
  font-family: var(--ids-font-family-default);
  font-size: var(--ids-font-size-30);
  white-space: nowrap;
  line-height: var(--ids-badge-font-line-height);
  margin-bottom: var(--ids-badge-margin-bottom);
  margin-inline-end: var(--ids-badge-margin-inline-end);
  min-width: var(--ids-badge-width-min);
  padding-inline: var(--ids-badge-padding-inline);
  flex-direction: column;
  justify-content: space-between;
}
.ids-badge.round {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  height: var(--ids-size-10);
  padding: var(--ids-space-none);
  width: var(--ids-size-10);
}
.ids-badge[color=info] {
  background-color: var(--ids-badge-color-background-info);
  border-color: var(--ids-badge-color-border-info);
  color: var(--ids-badge-color-text-info);
}
.ids-badge[color=success] {
  background-color: var(--ids-badge-color-background-success);
  border-color: var(--ids-badge-color-border-success);
  color: var(--ids-badge-color-success);
}
.ids-badge[color=caution] {
  background-color: var(--ids-badge-color-background-caution);
  border-color: var(--ids-badge-color-border-caution);
  color: var(--ids-badge-color-text-caution);
}
.ids-badge[color=warning] {
  background-color: var(--ids-badge-color-background-warning);
  border-color: var(--ids-badge-color-border-warning);
  color: var(--ids-badge-color-text-warning);
}
.ids-badge[color=error] {
  background-color: var(--ids-badge-color-background-error);
  border-color: var(--ids-badge-color-border-error);
  color: var(--ids-badge-color-text-error);
}`;var l=d(n),e=class extends l{constructor(){super()}connectedCallback(){super.connectedCallback(),this.color&&(this.color=this.getAttribute("color"))}static get attributes(){return[r.COLOR,r.DISABLED,r.SHAPE]}template(){return`<span class="ids-badge ${this.shape}" part="badge"><slot></slot></span>`}get shape(){return this.getAttribute("shape")||"normal"}set shape(o){o?this.setAttribute("shape",o.toString()):this.removeAttribute("shape"),this.container?.classList.remove("normal","round"),this.container?.classList.add(this.shape)}get color(){return this.getAttribute("color")}set color(o){o?(this.setAttribute("color",o),this.container?.setAttribute("color",o),(o==="error"||o==="info"||o==="warning")&&this.container?.classList.add("ids-white")):(this.removeAttribute("color"),this.container&&(this.container?.removeAttribute("color"),this.container.style.backgroundColor="",this.container.style.borderColor="",this.container.style.color="",this.container.style.position=""))}set disabled(o){a(o)?this.setAttribute(r.DISABLED,""):this.removeAttribute(r.DISABLED)}get disabled(){return this.hasAttribute(r.DISABLED)}};e=t([i("ids-badge"),s(c)],e);export{e as a};
